import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show } from "@clerk/react";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { MeProvider, useMe, can } from "@/context/MeContext";
import Layout from "@/components/Layout";
import CrudPage from "@/components/CrudPage";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import Accounts from "@/pages/Accounts";
import Pending from "@/pages/Pending";
import Epidemics from "@/pages/Epidemics";
import SyncPage from "@/pages/SyncPage";
import UserRecord from "@/pages/UserRecord";
import PatientRecord from "@/pages/PatientRecord";
import TabbedModule from "@/pages/TabbedModule";
import RecordsPage from "@/pages/RecordsPage";
import DoctorsPage from "@/pages/DoctorsPage";
import ApiKeysPage from "@/pages/ApiKeysPage";
import DirectoryPage from "@/pages/DirectoryPage";
import AiPage from "@/pages/AiPage";
import TrashPage from "@/pages/TrashPage";
import * as C from "@/pages/spConfigs";

const REF_TABS = [{ key: "pathologies", config: C.pathologiesConfig }, { key: "drugs", config: C.drugsConfig }, { key: "facilities", config: C.facilitiesConfig }];

const Shell = () => {
  const me = useMe();
  if (me.role === "pending") return <Pending />;
  return (
    <Layout>
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="utilisateurs" element={<CrudPage key="users" config={C.usersConfig} />} />
        <Route path="utilisateurs/:id" element={<UserRecord />} />
        <Route path="enfants" element={<CrudPage key="patients" config={C.patientsConfig} />} />
        <Route path="enfants/:id" element={<PatientRecord />} />
        <Route path="medecins" element={<DoctorsPage />} />
        <Route path="rendez-vous" element={<CrudPage key="appointments" config={C.appointmentsConfig} />} />
        <Route path="dossiers" element={<RecordsPage />} />
        <Route path="referentiels" element={<TabbedModule key="refs" testId="referentials-page" title="Référentiels" subtitle="Pathologies, médicaments et établissements utilisés par l'application. Toute modification y est envoyée." tabs={REF_TABS} />} />
        <Route path="synchronisation" element={<SyncPage />} />
        {can(me, "accounts") && <Route path="administrateurs" element={<Accounts />} />}
        {can(me, "accounts") && <Route path="cles-api" element={<ApiKeysPage />} />}
        <Route path="annuaire" element={<DirectoryPage />} />
        {can(me, "ai") && <Route path="assistant-ia" element={<AiPage />} />}
        {can(me, "delete") && <Route path="corbeille" element={<TrashPage />} />}
        <Route path="epidemies" element={<Epidemics />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
};

const Protected = () => (
  <>
    <Show when="signed-in"><MeProvider><Shell /></MeProvider></Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <Routes>
          <Route path="/sign-in/*" element={<AuthPage mode="sign-in" />} />
          <Route path="/sign-up/*" element={<AuthPage mode="sign-up" />} />
          <Route path="/*" element={<Protected />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
